"use client";

import { cn } from "@ui/lib/utils";

import "./FakeProgressBar.css";

export function FakeProgressBarV2({
  duration,
  isComplete = false,
  className,
}: {
  duration: number;
  isComplete?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn("tw-relative tw-h-[6px] tw-w-full tw-overflow-hidden tw-rounded-[4px] tw-bg-[#EBE8E4]", className)}
      style={{ "--progress-duration": `${duration}s` } as React.CSSProperties}
    >
      <div
        className={cn(
          "fake-progress-bar tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-rounded-[4px] tw-bg-black",
          isComplete && "is-complete",
        )}
      />
    </div>
  );
}

export default FakeProgressBarV2;
